<template>
  <div class="d-flex justify-content-end w-100">
    <b-button
      pill
      variant="danger"
      class="w-100 w-md-auto my-3 my-md-auto"
      :disabled="modalDisabled"
      @click="withdraw"
      aria-label="Withdraw FON"
    >
      Withdraw FON
    <b-modal
      ref="withdrawConfirmation"
      content-class="px-lg-5"
      id="withdrawConfirmation"
      title="Withdraw FON"
      footer-class="text-center"
      centered
      hide-header-close
      size="lg"
    >
      You are withdrawing this FON from certification by the other participants. This action will
      return this FON back to "Draft" status and will allow you to make corrections and/or changes.
      All previous acknowledgements and certifications will be deleted. After you make changes,
      you must certify and submit the FON again. Other FON participants will then be prompted to
      sign in to review and certify the FON. Are you sure you want to withdraw this FON?
      <div slot="modal-footer" class="d-flex">
        <b-button
          pill
          variant="danger"
          class="mr-3"
          @click="hideModal"
          aria-label="Cancel withdrawing this FON"
        >
          No
        </b-button>
        <b-button
          pill
          variant="primary"
          @click="withdrawn()"
          aria-label="Confirm withdrawing this FON"
          :disabled="mfsAdmin"
        >
          Yes, Withdraw
        </b-button>
      </div>
    </b-modal>
  </b-button>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Utilities from '@/mixins/Utilities';

export default {
  name: 'WithdrawModal',
  mixins: [Utilities],
  props: {
    modalDisabled: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState('Notification', {
      notification: state => state.notification,
    }),
    ...mapGetters('User', ['mfsAdmin']),
  },
  methods: {
    withdraw() {
      this.$refs.withdrawConfirmation.show();
    },
    withdrawn() {
      if (this.mfsAdmin) {
        return;
      }
      this.$store.dispatch(
        'Notification/withdraw',
        this.notification.id,
      );
      this.$emit('withdrawn');
    },
    hideModal() {
      this.$refs.withdrawConfirmation.hide();
    },
  },
};
</script>
